import React from 'react'
import ContentWrapper from '../shared/content-wrapper'
import SignForm from '../shared/sign-form'
import LoginForm from '../../services/session/login-form'
import redirectToHomeIfLoggedIn from '../../services/session/redirectToHomeIfLoggedIn'

const Login = props => (
  <ContentWrapper>
    <SignForm>
      <LoginForm />
    </SignForm>
  </ContentWrapper>
)

export default redirectToHomeIfLoggedIn(Login)



// WEBPACK FOOTER //
// ./src/ui/views/login.js